import React from 'react';
import { useSimulator } from '../../contexts/simulator';
import * as s from './styled-simulator-toggle';

// Botao flutuante do MODO SIMULADOR — renderizado so pro desenvolvedor
// (o gate isDeveloper fica em quem monta, no App). Liga/desliga dados
// fake temporarios pra formatar layout. Quando ativo, fica destacado.
const SimulatorToggle = () => {
  const { enabled, toggle } = useSimulator();

  return (
    <s.Button
      type="button"
      $active={enabled}
      onClick={toggle}
      title={
        enabled
          ? 'Modo simulador ATIVO — dados fake temporarios. Clique para desligar.'
          : 'Ativar modo simulador (dados fake temporarios, so pra visualizar layout)'
      }
      aria-pressed={enabled}
    >
      {/* lucide: flask-conical (simulacao/experimento) */}
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M10 2v7.31" />
        <path d="M14 9.3V2" />
        <path d="M8.5 2h7" />
        <path d="M14 9.3a6.5 6.5 0 1 1-4 0" />
        <path d="M5.58 16.5h12.85" />
      </svg>
      <span>Simulador{enabled ? ' ON' : ''}</span>
    </s.Button>
  );
};

export default SimulatorToggle;
